import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import App from "./App";
import Congratulations from "./pages/Congratulations";
import FinalScene from "./pages/FinalScene";
import Gameover from "./pages/Gameover";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Presentation from "./pages/Presentation";
import Results from "./pages/Results";
import Scenario1Intro from "./pages/Scenario1/Scenario1Intro";
import Scenario1Intro2 from "./pages/Scenario1/Scenario1Intro2";

import Scenario2Intro from "./pages/Scenario2/Scenario2Intro";
import Scenario2Fin from "./pages/Scenario2/Scenario2Fin";
import Scenario2Quiz1 from "./pages/Scenario2/Scenario2Quiz1";
import Scenario2Quiz2 from "./pages/Scenario2/Scenario2Quiz2";
import Scenario2Quiz3 from "./pages/Scenario2/Scenario2Quiz3";
import Scenario2Quiz4 from "./pages/Scenario2/Scenario2Quiz4";
import Scenario2Quiz5 from "./pages/Scenario2/Scenario2Quiz5";
import Scenario2Quiz6 from "./pages/Scenario2/Scenario2Quiz6";
import Scenario2Context1 from "./pages/Scenario2/Scenario2Context1";
import Scenario2Context2 from "./pages/Scenario2/Scenario2Context2";
import Scenario2Context3 from "./pages/Scenario2/Scenario2Context3";
import Scenario2Context4 from "./pages/Scenario2/Scenario2Context4";
import Scenario2Context5 from "./pages/Scenario2/Scenario2Context5";
import Scenario2Context6 from "./pages/Scenario2/Scenario2Context6";

import Scenario3Intro from "./pages/Scenario3/Scenario3Intro";
import Scenario3Quiz1 from "./pages/Scenario3/Scenario3Quiz1";
import Scenario3Quiz2 from "./pages/Scenario3/Scenario3Quiz2";
import Scenario3Quiz3 from "./pages/Scenario3/Scenario3Quiz3";
import Scenario3Quiz4 from "./pages/Scenario3/Scenario3Quiz4";
import Scenario3Quiz5 from "./pages/Scenario3/Scenario3Quiz5";
import Scenario3Quiz6 from "./pages/Scenario3/Scenario3Quiz6";
import Scenario3Context1 from "./pages/Scenario3/Scenario3Context1";
import Scenario3Context2 from "./pages/Scenario3/Scenario3Context2";
import Scenario3Context3 from "./pages/Scenario3/Scenario3Context3";
import Scenario3Context4 from "./pages/Scenario3/Scenario3Context4";
import Scenario3Context5 from "./pages/Scenario3/Scenario3Context5";
import Scenario3Context6 from "./pages/Scenario3/Scenario3Context6";
import Scenario3Fin from "./pages/Scenario3/Scenario3Fin";

import Scenario4Intro from "./pages/Scenario4/Scenario4Intro";
import Scenario4Fin from "./pages/Scenario4/Scenario4Fin";
import Scenario4Quiz1 from "./pages/Scenario4/Scenario4Quiz1";
import Scenario4Quiz2 from "./pages/Scenario4/Scenario4Quiz2";
import Scenario4Quiz3 from "./pages/Scenario4/Scenario4Quiz3";
import Scenario4Quiz4 from "./pages/Scenario4/Scenario4Quiz4";
import Scenario4Quiz5 from "./pages/Scenario4/Scenario4Quiz5";
import Scenario4Quiz6 from "./pages/Scenario4/Scenario4Quiz6";
import Scenario4Quiz7 from "./pages/Scenario4/Scenario4Quiz7";
import Scenario4Context1 from "./pages/Scenario4/Scenario4Context1";
import Scenario4Context2 from "./pages/Scenario4/Scenario4Context2";
import Scenario4Context3 from "./pages/Scenario4/Scenario4Context3";
import Scenario4Context4 from "./pages/Scenario4/Scenario4Context4";
import Scenario4Context5 from "./pages/Scenario4/Scenario4Context5";
import Scenario4Context6 from "./pages/Scenario4/Scenario4Context6";

import Scenario5 from "./pages/Scenario5/Scenario5";
import Scenario5Intro from "./pages/Scenario5/Scenario5Intro";
import Scenario5Quiz1 from "./pages/Scenario5/Scenario5Quiz1";
import Scenario5Quiz2 from "./pages/Scenario5/Scenario5Quiz2";
import Scenario5Quiz3 from "./pages/Scenario5/Scenario5Quiz3";
import Scenario5Quiz4 from "./pages/Scenario5/Scenario5Quiz4";
import Scenario5Quiz5 from "./pages/Scenario5/Scenario5Quiz5";
import Scenario5Quiz6 from "./pages/Scenario5/Scenario5Quiz6";
import Scenario5Context1 from "./pages/Scenario5/Scenario5Context1";
import Scenario5Context2 from "./pages/Scenario5/Scenario5Context2";
import Scenario5Context3 from "./pages/Scenario5/Scenario5Context3";
import Scenario5Context4 from "./pages/Scenario5/Scenario5Context4";
import Scenario5Context5 from "./pages/Scenario5/Scenario5Context5";
import Scenario5Context6 from "./pages/Scenario5/Scenario5Context6";
import Scenario5Fin from "./pages/Scenario5/Scenario5Fin";

import StartGame from "./pages/StartGame";
import StartGame2 from "./pages/StartGame2";
import StartGame3 from "./pages/StartGame3";
import StartGame4 from "./pages/StartGame4";
import StartGame5 from "./pages/StartGame5";
import Supertest from "./pages/Supertest/Supertest";
import SupertestInstructions from "./pages/Supertest/SupertestInstructions";
import SupertestIntro from "./pages/Supertest/SupertestIntro";
import TransitionScenarios from "./pages/TransitionScenarios";
import { ROUTES } from "./utils/constants";


import WarmupPage from "./pages/WarmupPage";

export default function Rutas() {
	const isRegistered = useSelector((state) => state.group, shallowEqual);

	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<App />}>
					<Route path="/" element={<Home />} />
					<Route path={ROUTES.REGISTER} element={<Register />} />

					<Route path="warmup" element={<WarmupPage />} />
					
					{!isRegistered ? (
						/*Render register page when not registered.*/
						<Route path="*" element={<Navigate to="/" replace />} />
					) : (
						<Route>
							<Route
								path={ROUTES.PRESENTATION}
								element={<Presentation />}
							/>
							<Route
								path={ROUTES.START_GAME}
								element={<StartGame />}
							/>
							<Route
								path={ROUTES.START_GAME2}
								element={<StartGame2 />}
							/>
							<Route
								path={ROUTES.START_GAME3}
								element={<StartGame3 />}
							/>
							<Route
								path={ROUTES.START_GAME4}
								element={<StartGame4 />}
							/>
							<Route
								path={ROUTES.START_GAME5}
								element={<StartGame5 />}
							/>
							<Route
								path={ROUTES.TRANSITION_SCENARIOS}
								element={<TransitionScenarios />}
							/>

							{/*Scenario 1*/}
							<Route
								path={ROUTES.SCENARIO1_INTRO}
								element={<Scenario1Intro />}
							/>
							<Route
								path={ROUTES.SCENARIO1_INTRO2}
								element={<Scenario1Intro2 />}
							/>
							<Route
								path={ROUTES.SCENARIO1_INSTRUCTIONS}
								element={
									<Navigate
										to={ROUTES.TRANSITION_SCENARIOS}
										replace
										state={{ activeScenario: 2 }}
									/>
								}
							/>

							{/*Scenario 2*/}
							<Route
								path={ROUTES.SCENARIO2_INTRO}
								element={<Scenario2Intro />}
							/>
							<Route
								path={ROUTES.SCENARIO2_FIN}
								element={<Scenario2Fin />}
							/>
							<Route
								path={ROUTES.SCENARIO2}
								element={
									<Navigate to={ROUTES.SCENARIO2_CONTEXT1} replace />
								}
							/>
							<Route
								path={ROUTES.SCENARIO2_QUIZ1}
								element={<Scenario2Quiz1 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_QUIZ2}
								element={<Scenario2Quiz2 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_QUIZ3}
								element={<Scenario2Quiz3 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_QUIZ4}
								element={<Scenario2Quiz4 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_QUIZ5}
								element={<Scenario2Quiz5 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_QUIZ6}
								element={<Scenario2Quiz6 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_CONTEXT1}
								element={<Scenario2Context1 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_CONTEXT2}
								element={<Scenario2Context2 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_CONTEXT3}
								element={<Scenario2Context3 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_CONTEXT4}
								element={<Scenario2Context4 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_CONTEXT5}
								element={<Scenario2Context5 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_CONTEXT6}
								element={<Scenario2Context6 />}
							/>

							{/*Scenario 3*/}
							<Route
								path={ROUTES.SCENARIO3_INTRO}
								element={<Scenario3Intro />}
							/>
							<Route
								path={ROUTES.SCENARIO3}
								element={
									<Navigate to={ROUTES.SCENARIO3_CONTEXT1} replace />
								}
							/>
							<Route
								path={ROUTES.SCENARIO3_QUIZ1}
								element={<Scenario3Quiz1 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_QUIZ2}
								element={<Scenario3Quiz2 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_QUIZ3}
								element={<Scenario3Quiz3 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_QUIZ4}
								element={<Scenario3Quiz4 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_QUIZ5}
								element={<Scenario3Quiz5 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_QUIZ6}
								element={<Scenario3Quiz6 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_CONTEXT1}
								element={<Scenario3Context1 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_CONTEXT2}
								element={<Scenario3Context2 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_CONTEXT3}
								element={<Scenario3Context3 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_CONTEXT4}
								element={<Scenario3Context4 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_CONTEXT5}
								element={<Scenario3Context5 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_CONTEXT6}
								element={<Scenario3Context6 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_FIN}
								element={<Scenario3Fin />}
							/>

							{/*Scenario 4*/}
							<Route
								path={ROUTES.SCENARIO4_INTRO}
								element={<Scenario4Intro />}
							/>
							<Route
								path={ROUTES.SCENARIO4}
								element={
									<Navigate to={ROUTES.SCENARIO4_QUIZ1} replace />
								}
							/>
							<Route
								path={ROUTES.SCENARIO4_QUIZ1}
								element={<Scenario4Quiz1 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_QUIZ2}
								element={<Scenario4Quiz2 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_QUIZ3}
								element={<Scenario4Quiz3 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_QUIZ4}
								element={<Scenario4Quiz4 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_QUIZ5}
								element={<Scenario4Quiz5 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_QUIZ6}
								element={<Scenario4Quiz6 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_QUIZ7}
								element={<Scenario4Quiz7 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_CONTEXT1}
								element={<Scenario4Context1 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_CONTEXT2}
								element={<Scenario4Context2 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_CONTEXT3}
								element={<Scenario4Context3 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_CONTEXT4}
								element={<Scenario4Context4 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_CONTEXT5}
								element={<Scenario4Context5 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_CONTEXT6}
								element={<Scenario4Context6 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_FIN}
								element={<Scenario4Fin />}
							/>

							{/*Scenario 5*/}
							<Route
								path={ROUTES.SCENARIO5_INTRO}
								element={<Scenario5Intro />}
							/>
							<Route
								path={ROUTES.SCENARIO5}
								element={<Scenario5 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_QUIZ1}
								element={<Scenario5Quiz1 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_CONTEXT1}
								element={<Scenario5Context1 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_QUIZ2}
								element={<Scenario5Quiz2 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_QUIZ3}
								element={<Scenario5Quiz3 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_CONTEXT2}
								element={<Scenario5Context2 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_QUIZ4}
								element={<Scenario5Quiz4 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_QUIZ5}
								element={<Scenario5Quiz5 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_QUIZ6}
								element={<Scenario5Quiz6 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_CONTEXT3}
								element={<Scenario5Context3 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_CONTEXT4}
								element={<Scenario5Context4 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_CONTEXT5}
								element={<Scenario5Context5 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_CONTEXT6}
								element={<Scenario5Context6 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_FIN}
								element={<Scenario5Fin />}
							/>

							{/*Supertest */}
							<Route
								path={ROUTES.SUPERTEST_INTRO}
								element={<SupertestIntro />}
							/>
							<Route
								path={ROUTES.SUPERTEST_INSTRUCTIONS}
								element={<SupertestInstructions />}
							/>
							<Route
								path={ROUTES.SUPERTEST}
								element={<Supertest />}
							/>
							<Route
								path={ROUTES.SUPERTEST_2}
								element={<Supertest />}
							/>
							<Route
								path={ROUTES.SUPERTEST_3}
								element={<Supertest />}
							/>
							<Route
								path={ROUTES.FINAL_SCENE}
								element={<FinalScene />}
							/>
							<Route
								path={ROUTES.CONGRATULATIONS}
								element={<Congratulations />}
							/>
							<Route
								path={ROUTES.RESULTS}
								element={<Results />}
							/>
							<Route
								path={ROUTES.GAMEOVER}
								element={<Gameover />}
							/>
						</Route>
					)}
				</Route>
			</Routes>
		</BrowserRouter>
	);
}
